<template>
    <section class="property-poi section-outline" >
        <mvtCollapse :disable="disableCollapse" :isActive="isActive" v-if="getNearbyPois && getNearbyPois.length">
            <template v-slot:header>
                <h2 class="f2 text-bold">
                    Nearby places of interest <sub class="sub">Places around {{ dpp.geo.address }}</sub>
                </h2>
            </template>
            <template v-slot:default>
                <div class="grid xs-grid-cols-1">
                    <div class="poi-category" v-if="getNearbyPois && getNearbyPois.length">
                        <button type="button" v-for="(item,i) in getNearbyPois" :key="item.name" @click="select(i)"  class="btn cate-tab small" :class="{'active': index=== i}">{{item.poiTypeName}}</button>
                    </div>
                    <template v-if="filteredPois.length">
                        <div class="poi-panel" @click="popMapView" v-for="item in filteredPois" :key="item.name">
                            <i class="poi-icon active circle small" :class="`${selectedPois.icon}`"></i>
                            <div class="singleline poi-name">
                                {{item.name}}
                            </div>
                            <div v-if="item.distance">{{item.distance.toFixed(2)}} mi</div>
                        </div>
                    </template>
                    <button class="f6 text-brand text-bold text-left m-t-1"  @click="popMapView" type="button">
                        View more <i class="icon-angle-right"></i>
                    </button>
                </div>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-poi.js"></script>

<style lang="scss">
@use "./property-poi.scss" as *;
</style>
